<template>
	<div @click="clickCallback" class="label-container">
		<div class="row wrapper-row">
			<label v-if="label" :for="id">{{ label }}</label>
			<input type="checkbox" :name="name" :id="id" :checked="active">
			<span class="checkmark"></span>
		</div>
	</div>
</template>

<script>
import {getRandomAlphanumericString} from "@/shared/helpers/strings";

export default {
	name: "AppCheckbox",
	emits: ["check-toggle"],
	props: {
		name: {type: String, default: "checkbox"},
		label: {type: String, default: null},
		autoToggle: {type: Boolean, default: true},
		isActive: {type: Boolean, default: false},
	},
	data() {
		return {
			active: this.isActive
		}
	},
	computed: {
		id() {
			return 'checkbox-' + getRandomAlphanumericString();
		},
	},
	methods: {
		clickCallback() {
			if (this.autoToggle) {
				this.active = !this.active;
				this.$emit("check-toggle", this.active, () => {
				});
			} else {
				this.$emit("check-toggle", !this.active, () => {
					this.active = !this.active;
				});
			}
		},
	},
	watch: {
		isActive(newValue) {
			this.active = newValue;
		}
	}
}
</script>

<style lang="scss" scoped>

.label-container {
	display: block;
	position: relative;
	cursor: pointer;
	font-size: 22px;
	width: 100%;
	height: 100%;
	@include noSelect();

	& * {
		@include noSelect();
		pointer-events: none;
	}

	.wrapper-row {
		@include centered;
		position: relative;
		height: 100%;
	}

	input {
		position: absolute;
		opacity: 0;
		cursor: pointer;
	}

	.checkmark {
		position: absolute;
		top: 50%;
		left: 15px;
		height: 15px;
		width: 15px;
		border-radius: 5px;
		background-color: var(--color-bg);
		box-shadow: 0 1px 3px var(--color-box-shadow-3);
		transform: translateY(-50%);

		&:after {
			content: "";
			position: absolute;
			display: block;
			top: 3px;
			left: 3px;
			width: 9px;
			height: 9px;
			border-radius: 3px;
			background: var(--color-bg-primary-2);
			box-shadow: inset 0 1px 1px var(--color-box-shadow-3);
		}
	}

	input:checked ~ .checkmark {
		box-shadow: 0 0 2px $alpha;
	}

	input:checked ~ .checkmark:after {
		background-color: $secondary;
	}

	label {
		color: $txt_1;
	}
}
</style>